import { useEffect, useState } from 'react';
import { Autocomplete, IconButton, Popper, Tooltip } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Swal from 'sweetalert2';
import { format } from 'date-fns';
import { useRef } from 'react';
import {
    FormGroup, FormControlLabel, Checkbox, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Grid, TextField
} from "@mui/material";
import {
    Add as AddIcon,
    Delete as DeleteIcon
} from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import { FormLabel, RadioGroup, FormControl, Radio, Select, InputLabel, MenuItem } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CustomAutocomplete from '../../../Components/AutoComplete/AutoComplete';
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import { useReactToPrint } from 'react-to-print';
import axiosInstance from '../../../lib/axios';
import moment from 'moment';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import PrintAssetAlloc from './PrintAssetAlloc';

const tableColumns = [
    { id: 'AssetDocNo', label: 'AssetDoc-No', minWidth: 50 },
    { id: 'VendName', label: 'Vendor', minWidth: 50 },
    { id: 'BillDt', label: 'Date', minWidth: 50 },
    { id: 'BillNo', label: 'BillNo', minWidth: 50 },
    { id: 'ItmName', label: 'Item', minWidth: 50 },
    { id: 'ItmCatName', label: 'CatName', minWidth: 50 },
    { id: 'ItmGrpName', label: 'GrpName', minWidth: 50 },
    { id: 'ItmSubGrpName', label: 'SubGrpName', minWidth: 50 },
    { id: 'BarcodeNo', label: 'BarcodeNo', minWidth: 50 },
    { id: 'BalQty', label: 'BalQty', minWidth: 50 },
    { id: 'Rate', label: 'Rate', minWidth: 50 },
];

// Main component for Asset Allocation
const AssetAlloc = () => {
    const [formData, setFormData] = useState({
        PropId: "",
        EnqNo: "",
        BillDt: moment().format('DD/MM/YYYY'),
        Rate: "",
        EnqType: "",
        ItmName: "",
        BillNo: "",
        ModelBrand: "",
        EmpId: "",
        VendName: "",
        Tenure: "",
        CheckInDt: moment().format('DD/MM/YYYY'),
        Qty: "",
        Remark: "",
        Status: "",
        VisitRemark: "",
        CreatedBy: "",
        RelationId: "",
        DepAccLedId: "",
        SgrnNo: "",
        AssetDocNo: "",
        ItmName: "",
        assetLocation: "",
        ItemCategory: "",
        ItmGrpName: "",
        ItmSubGrpName: "",
        ItmGrpName: "",
    });

    // State for table data and various UI controls
    const [tableData, setTableData] = useState([]);
    const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
    const [areTableButtonsDisabled, setAreTableButtonsDisabled] = useState(true);
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [internalMode, setInternalMode] = useState("add");
    const [addDisabled, setAddDisabled] = useState(true);
    const [allButtonDisabled, setAllButtonDisabled] = useState(true);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [fetchedData, setFetchedData] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [locationSearchTerm, setLocationSearchTerm] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [ledgerOptions, setLedgerOptions] = useState([]);
    const [serviceProviderOptions, setServiceProviderOptions] = useState([]);
    const [selectedAssetDetails, setSelectedAssetDetails] = useState([]);
    const [isLoadingLocations, setIsLoadingLocations] = useState(false);
    const [fetchedQty, setFetchedQty] = useState(0);
    const [selectedAssetData, setSelectedAssetData] = useState(null);
    const [isSelectionConfirmed, setIsSelectionConfirmed] = useState(false);
    const [originalQty, setOriginalQty] = useState(0);
    const [isPropertyDropdownDisabled, setIsPropertyDropdownDisabled] = useState(true);
    const [currentRecordPosition, setCurrentRecordPosition] = useState({
        current: 0,
        total: 0
    });

    const [allocations, setAllocations] = useState({
        Unit: { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
        'Common Area': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
        Amenity: { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
        Floor: { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' }
    });
    const [selectedLocationTypes, setSelectedLocationTypes] = useState({
        Unit: false,
        'Common Area': false,
        Amenity: false,
        Floor: false
    });

    const [remainingQty, setRemainingQty] = useState(0);

    const [error, setError] = useState({
        ItmName: false,
        VendName: false,
        BillNo: false,
        CheckInDt: false
    });
    // Add this near your other state declarations
    const [locationModalOpen, setLocationModalOpen] = useState(false);
    const [custodianOptions, setCustodianOptions] = useState([]);
    const [isLoadingCustodians, setIsLoadingCustodians] = useState(false);
    const [locationFormData, setLocationFormData] = useState({
        allocateQty: '',
        custodian: '',
        perUnitQty: '',
        noOfLocation: ''
    });

    // Additional state variables
    const [selectedImage, setSelectedImage] = useState(null);
    const navigate = useNavigate();
    const [mode, setMode] = useState('view');
    const location = useLocation();
    const [currentEnqId, setCurrentEnqId] = useState(null);
    const [currentDetailIds, setCurrentDetailIds] = useState([]);
    const [Status, setStatus] = useState("1");
    const UserId = sessionStorage.getItem('UserId');
    const [Propertydrp, setPropertydrp] = useState([]);
    const [Propertydrpdata, setPropertydrpdata] = useState();
    const [Relation, setRelation] = useState([]);
    const [showCalendar, setShowCalendar] = useState(false);
    const [displayCalendar, setDisplayCalendar] = useState(false);
    const [viewCalendar, setViewCalendar] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [isFormEditable, setIsFormEditable] = useState(false);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    // Refs for input focus
    const RateRef = useRef(null);
    const EnqTypeRef = useRef(null);
    const BillNoRef = useRef(null);

    // Initial setup and data fetching
    useEffect(() => {
        if (location.state && location.state?.EnqId) {
            setCurrentEnqId(location.state.EnqId);
            fetchAssetData(location.state?.EnqId, "R");
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(true);
        }
        fetchPropertyData();
    }, [location]);

    // Update form data when a table row is selected
    useEffect(() => {
        if (selectedRowIndex >= 0 && tableData.length > 0) {
            const selectedRow = tableData[selectedRowIndex];
            setFormData({
                ...formData,
                SgrnNo: selectedRow.SgrnNo || "",
                VendName: selectedRow.VendName || "",
                BillDt: selectedRow.BillDt || moment().format('DD/MM/YYYY'),
                BillNo: selectedRow.BillNo || "",
                ItmName: selectedRow.ItmName || "",
                Qty: selectedRow.Qty || "",
                Rate: selectedRow.Rate || "",
                ModelBrand: selectedRow.ModelBrand || "",
                Tenure: selectedRow.WarrantyPeriod || "",
            });
            setAllButtonDisabled(false);
            setAddDisabled(false);
        }
    }, [selectedRowIndex]);

    useEffect(() => {
        if (location.state && location.state?.MstAssetId) {
            setCurrentEnqId(location.state.MstAssetId);
            setMode('view');
            setIsFormDisabled(true);

            if (location.state.rowData) {
                setFormData({
                    ...formData,
                    PropId: location.state.rowData.PropId || "",
                    SgrnId: location.state.rowData.SgrnId || "",
                    SgrnDt: location.state.rowData.SgrnDt || "",
                    ItmId: location.state.rowData.ItmId || "",
                    Qty: location.state.rowData.Qty || "",
                    Rate: location.state.rowData.Rate || "",
                    ModelNo: location.state.rowData.ModelNo || "",
                    ModelBrand: location.state.rowData.ModelBrand || "",
                    ModelColour: location.state.rowData.ModelColour || "",
                    ModelClass: location.state.rowData.ModelClass || "",
                    ModelOemPartNo: location.state.rowData.ModelOemPartNo || "",
                    WarrantyPeriod: location.state.rowData.WarrantyPeriod || "",
                    WarrantyUpto: location.state.rowData.WarrantyUpto || "",
                    ExpLife: location.state.rowData.ExpLife || "",
                    RelationId: location.state.rowData.RelationId || "",
                    MaintFreq: location.state.rowData.MaintFreq || "",
                    DepAccLedId: location.state.rowData.DepAccLedId || "",
                    DepRate: location.state.rowData.DepRate || "",
                    Remark: location.state.rowData.Remark || "",
                    Status: location.state.rowData.Status || "1"
                });
            }
        } else {
            setMode('add');
            setIsFormDisabled(false); // Enable form in add mode
        }
        fetchPropertyData();
    }, [location]);

    // Fetch property dropdown data
    const fetchPropertyData = async () => {
        try {
            const response = await axios.post(
                `PropertyMst/GetPropertyMstUserwisedrp`,
                {
                    UserId,
                    Flag: ""
                }
            );
            if (response.data.Status === 0) {
                setPropertydrp(response.data.Data);

                // Set the first property as default in formData if there's data
                if (response.data.Data && response.data.Data.length > 0) {
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        PropId: response.data.Data[0].Id
                    }));
                }
            }
        } catch (error) {
            toast.error('Error fetching Property data');
        }
    };

    // Placeholder for fetching asset data
    const fetchAssetData = async () => {
        // To be implemented with actual API call
    };

    const fetchCustodians = async () => {
        try {
            setIsLoadingCustodians(true);
            const response = await axiosInstance.post('MstEmp/getMstEmpdrp', {});

            if (response.data && Array.isArray(response.data.Data)) {
                setCustodianOptions(response.data.Data.map(item => ({
                    id: item.Id || item.EmpId || item.id, // Use appropriate ID field from your API
                    name: item.Name
                })));
            } else {
                toast.error('Invalid custodian data format received');
                setCustodianOptions([]);
            }
        } catch (error) {
            toast.error('Error fetching custodians');
            setCustodianOptions([]);
        } finally {
            setIsLoadingCustodians(false);
        }
    };

    // Call this in your useEffect where you fetch other data
    useEffect(() => {
        fetchCustodians();
    }, []);

    const fetchDialogData = async () => {
        try {
            const response = await axios.post('MstAsset/GetSelectMstAssetAll', {
                MstAssetId: "",
                Flag: "",
                PropId: formData.PropId,
            });

            if (response.data && Array.isArray(response.data.Data)) {
                const mappedData = response.data.Data.map((item, index) => ({
                    MstAssetId: item.MstAssetId || null,
                    MstAssetDtlId: item.MstAssetDtlId || null,
                    SgrnId: item.SgrnId || 0,
                    SgrnNo: item.SgrnNo || "",
                    AssetDocNo: item.AssetDocNo || "",
                    SgrnItmId: item.SgrnItmId || 0,
                    ItmId: item.ItmId || 0,
                    ItmName: item.ItmName || "",
                    SgrnDt: item.SgrnDt ? moment(item.SgrnDt).format('DD/MM/YYYY') : "",
                    VendId: item.VendId || 0,
                    VendDtlId: item.VendDtlId || 0,
                    VendName: item.VendName || "",
                    ActVendId: item.ActVendId || 0,
                    ActVendDtlId: item.ActVendDtlId || 0,
                    BillNo: item.BillNo || "",
                    BillDt: item.BillDt ? moment(item.BillDt).format('DD/MM/YYYY') : "",
                    ModelBrand: item.ModelBrand || "",
                    ModelNo: item.ModelNo || "",
                    ModelColour: item.ModelColour || "",
                    ModelClass: item.ModelClass || "",
                    ModelOemPartNo: item.ModelOemPartNo || "",
                    Qty: item.Qty || 0,
                    Rate: item.Rate || 0,
                    BalQty: item.BalQty || 0,
                    ExpLife: item.ExpLife || 0,
                    DepAccLedId: item.DepAccLedId || 0,
                    DepRate: item.DepRate || 0,
                    WarrantyPeriod: item.WarrantyPeriod || 0,
                    ItmCatName: item.ItmCatName || 0,
                    ItmGrpName: item.ItmGrpName || 0,
                    ItmSubGrpName: item.ItmSubGrpName || 0,
                    BarcodeNo: item.BarcodeNo || 0,
                    WarrantyUpto: item.WarrantyUpto || 0,
                    MaintFreq: item.MaintFreq || 0,
                    SerProvId: item.SerProvId || 0,
                    SerProvDtlId: item.SerProvDtlId || 0,
                    Remark: item.Remark || "",
                    Status: item.Status || "1",
                    CreatedBy: item.UserId || parseInt(UserId) || 0,
                    DBFLAG: "I" // Default to Insert for new items
                }));

                setFetchedData(mappedData);
                if (mappedData.length > 0) {
                    const balQty = parseFloat(mappedData[0].BalQty) || 0;
                    const qty = parseFloat(mappedData[0].Qty) || 0;

                    setFetchedQty(balQty);
                    setSelectedAssetData(mappedData[0]);
                    setOriginalQty(balQty);

                    // Update formData with the correct values
                    setFormData(prev => ({
                        ...prev,
                        BalQty: balQty,
                        Qty: qty
                    }));
                }
            } else {
                setFetchedData([]);
                toast.error("No data Found in this property");
            }
        } catch (error) {
            setFetchedData([]);
            toast.error(`Error fetching data: ${error.message || 'Unknown error'}`);
        }
    };

    const handleLocationSelect = (event, location) => {
        const noOfLocation = parseInt(locationFormData.noOfLocation) || 0;

        if (event.target.checked) {
            if (selectedLocations.length < noOfLocation) {
                setSelectedLocations([...selectedLocations, location]);
            } else {
                event.target.checked = false; // Prevent checking if limit reached
                toast.error(`You can only select ${noOfLocation} locations`);
            }
        } else {
            setSelectedLocations(selectedLocations.filter(item => item.Id !== location.Id));
        }
    };

    // Add this function to handle search term changes
    const handleLocationSearch = (event) => {
        setLocationSearchTerm(event.target.value.toLowerCase());
    };

    // Filter locations based on search term
    const filteredLocations = formData.assetLocation && locationOptions[formData.assetLocation]
        ? locationOptions[formData.assetLocation].filter(location =>
            location.Name.toLowerCase().includes(locationSearchTerm))
        : [];

    const handleLocationFormChange = (event) => {
        const { name, value } = event.target;
        const allocateQty = parseInt(formData.Qty) || 0;

        // In your handleLocationFormChange or wherever you handle these inputs
        if (name === 'perUnitQty') {
            const newPerUnitQty = parseInt(value) || 0;
            if (newPerUnitQty <= 0) {
                toast.error("Per Unit Qty must be greater than 0");
                return;
            }

            if (newPerUnitQty > fetchedQty) {
                toast.error("Per Unit Qty cannot exceed total available quantity");
                return;
            }

            const maxNoOfLocation = Math.floor(fetchedQty / newPerUnitQty);
            const calculatedNoOfLocation = Math.min(maxNoOfLocation, parseInt(locationFormData.noOfLocation) || maxNoOfLocation);

            setLocationFormData(prev => ({
                ...prev,
                perUnitQty: value,
                noOfLocation: calculatedNoOfLocation.toString()
            }));
            return;
        }

        if (name === 'noOfLocation') {
            const newNoOfLocation = parseInt(value) || 0;
            const perUnitQty = parseInt(locationFormData.perUnitQty) || 0;

            if (perUnitQty <= 0) {
                toast.error("Please Enter Per Unit Qty first");
                return;
            }

            const totalAllocated = perUnitQty * newNoOfLocation;
            if (totalAllocated > fetchedQty) {
                toast.error(`Total allocated (${totalAllocated}) cannot exceed Allocate Qty (${fetchedQty})`);
                return;
            }

            setLocationFormData(prev => ({
                ...prev,
                [name]: value
            }));
            return;
        }
    };

    const handleLocationModalClose = () => {
        setLocationModalOpen(false);
    };

    const handleLocationModalSubmit = () => {
        const type = formData.assetLocation;
        const currentAllocation = allocations[type];

        if (!currentAllocation.perUnitQty || !currentAllocation.custodian) {
            toast.error("Please fill all required fields");
            return;
        }

        const { totalAllocated, remaining } = calculateRemainingQty();

        const thisAllocation = parseInt(currentAllocation.perUnitQty) * (currentAllocation.selected?.length || 0);

        // Update allocations
        setAllocations(prev => ({
            ...prev,
            [type]: {
                ...prev[type],
                perUnitQty: currentAllocation.perUnitQty,
                noOfLocation: currentAllocation.selected?.length || 0,
                custodian: currentAllocation.custodian
            }
        }));

        // Update remaining quantity
        setRemainingQty(originalQty - (totalAllocated + thisAllocation));
        setLocationModalOpen(false);
    };
    const handleInputChange = (event) => {
        // Handle both regular inputs and Autocomplete changes
        const { name, value } = event.target;

        // For Autocomplete, we might have the full option object
        const optionValue = event.target.option ? event.target.option.Id : value;
        setFormData({
            ...formData,
            [name]: optionValue
        });

        // Special handling for Property dropdown
        if (name === 'PropId') {
            setPropertydrpdata(optionValue);
        }
        // Special handling for Qty field
        if (name === 'Qty') {
            setLocationFormData(prev => ({
                ...prev,
                allocateQty: value,
                perUnitQty: '',
                noOfLocation: ''
            }));
        }
    };

    // Handle row selection in the table
    const handleRowClick = (index) => {
        setSelectedRowIndex(index);
        const selectedRow = tableData[index];

        // Update form data with the selected row's information
        setFormData(prev => ({
            ...prev,
            // Keep assetLocation value if it's already set, otherwise set to first allocated type
            assetLocation: prev.assetLocation || Object.entries(selectedRow.allocations || {}).find(
                ([_, alloc]) => alloc.selected?.length > 0
            )?.[0] || '',
            SgrnId: selectedRow.SgrnId || "",
            SgrnDt: selectedRow.SgrnDt || moment().format('DD/MM/YYYY'),
            ItmId: selectedRow.ItmId || "",
            Qty: selectedRow.Qty || "",
            Rate: selectedRow.Rate || "",
            BalQty: selectedRow.BalQty || 0,
        }));

        // Set the allocations for this row
        setAllocations(selectedRow.allocations || {
            'Unit': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
            'Common Area': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
            'Amenity': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
            'Floor': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' }
        });

        // Set the fetched quantity for allocation from this row
        setFetchedQty(selectedRow.BalQty || 0);
        setOriginalQty(selectedRow.Qty || 0);

        // Update selected location types based on allocations
        const types = {
            'Unit': false,
            'Common Area': false,
            'Amenity': false,
            'Floor': false
        };

        if (selectedRow.allocations) {
            Object.entries(selectedRow.allocations).forEach(([type, alloc]) => {
                if (alloc.selected?.length > 0) {
                    types[type] = true;
                }
            });
        }
        setSelectedLocationTypes(types);
        setAllButtonDisabled(false);
        setAddDisabled(false);
    };

    useEffect(() => {
        if (mode === 'edit' && tableData.length > 0 && selectedRowIndex >= 0) {
            const selectedRow = tableData[selectedRowIndex];
            setAllocations(selectedRow.allocations || {
                'Unit': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                'Common Area': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                'Amenity': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                'Floor': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' }
            });

            setOriginalQty(selectedRow.Qty || 0);
            setRemainingQty(selectedRow.BalQty || 0);
        }
    }, [mode]);
    // Open selection dialog for adding new items
    const handleClickAdd = () => {
        if (!formData.PropId) {
            toast.error("Please select a property first");
            return;
        }

        setInternalMode("add");
        fetchDialogData();
        setOpenDialog(true);
    };

    // Enable editing of selected row
    const handleClickEdit = () => {
        if (selectedRowIndex >= 0) {
            setInternalMode("edit");
            setIsFormEditable(true);
            setIsFormDisabled(false);
            setAllButtonDisabled(true);
            setAddDisabled(true);

            const selectedRow = tableData[selectedRowIndex];

            // Also reset the asset location selection
            setFormData(prev => ({
                ...prev,
                assetLocation: "",
                SgrnId: selectedRow.SgrnId || "",
                SgrnDt: selectedRow.SgrnDt || moment().format('DD/MM/YYYY'),
                ItmId: selectedRow.ItmId || "",
                Qty: selectedRow.Qty || "",
                Rate: selectedRow.Rate || "",
                ModelNo: selectedRow.ModelNo || "",
                ModelBrand: selectedRow.ModelBrand || "",
                ModelColour: selectedRow.ModelColour || "",
                ModelClass: selectedRow.ModelClass || "",
                ModelOemPartNo: selectedRow.ModelOemPartNo || "",
                WarrantyPeriod: selectedRow.WarrantyPeriod || "",
                WarrantyUpto: selectedRow.WarrantyUpto || "",
                ExpLife: selectedRow.ExpLife || "",
                RelationId: selectedRow.RelationId || "",
                MaintFreq: selectedRow.MaintFreq || "",
                DepAccLedId: selectedRow.DepAccLedId || "",
                DepRate: selectedRow.DepRate || "",
                Remark: selectedRow.Remark || "",
                Status: selectedRow.Status || "1",
                ItmCatName: selectedRow.ItmCatName || 0,
                ItmGrpName: selectedRow.ItmGrpName || 0,
                ItmSubGrpName: selectedRow.ItmSubGrpName || 0,
                BarcodeNo: selectedRow.BarcodeNo || 0,
            }));

            // If you need to log the mode, use a useEffect hook
        } else {
            toast.error("Please select a row to edit.");
        }
    };

    useEffect(() => {
        // console.log("Current internalMode:", internalMode);
    }, [internalMode]);

    // Confirm changes to table data
    const handleClickConfirm = () => {
        const requiredFields = ["ItmId", "Qty", "Rate"];
        if (requiredFields.some(field => !formData[field])) {
            toast.error("Please fill all required fields");
            return;
        }

        const updatedItem = {
            ...formData,
            DBFLAG: internalMode === "add" ? "I" : "U"
        };

        if (internalMode === "add") {
            // Check if item already exists in the table (only for add mode)
            if (!tableData.some(item => item.ItmId === updatedItem.ItmId && item.DBFLAG !== "D")) {

                if (tableData.length > 0 && tableData.some(row => row.DBFLAG !== "D")) {
                    toast.error("You can only have one item at a time. Please delete the existing item first.");
                    return;
                }
                setTableData([...tableData, updatedItem]);
                setSelectedRowIndex(tableData.length);
            } else {
                toast.error("This item already exists in the table");
                return;
            }
        } else {
            // In edit mode, always update the existing row regardless of field changes
            const updatedTableData = [...tableData];
            updatedTableData[selectedRowIndex] = {
                ...updatedTableData[selectedRowIndex], // Keep existing data
                ...updatedItem, // Apply changes
                DBFLAG: "U" // Mark as updated
            };
            setTableData(updatedTableData);
        }

        setIsFormDisabled(true); // Disable form fields
        setIsFormEditable(false); // Disable form editing
        setAddDisabled(true); // Disable below Add button
        setAllButtonDisabled(false);
    };

    // Cancel current operation
    const handleClickCancel = () => {
        setIsFormDisabled(true); // Disable form fields
        setIsFormEditable(false); // Disable form editing
        setAddDisabled(true); // Disable below Add button
        setAllButtonDisabled(false); // Enable other buttons
    };

    useEffect(() => {
        if (tableData.length > 0 && selectedRowIndex === -1) {
            setSelectedRowIndex(0); // Auto-select first row
        }
    }, [tableData]);

    const handleDelete = async () => {
        try {
            // Show confirmation dialog
            const result = await Swal.fire({
                title: 'Delete Asset Allocation',
                text: 'Are you sure you want to delete this asset allocation?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'Cancel'
            });

            if (!result.isConfirmed) {
                return;
            }

            const UserId = sessionStorage.getItem('UserId');

            const payload = {
                AssetAllocId: formData.AssetAllocId,
                PropId: formData.PropId,
                Flag: "New",
                ActionBy: parseInt(UserId) || 2
            };

            const response = await axiosInstance.post(
                'MstAsset/DeleteTrnAssetAlloct',
                payload
            );

            if (response.data && response.data.Status === 0) {
                toast.success(response.data.Message || "Asset allocation deleted successfully");
                handleClear();
            } else {
                toast.error(response.data?.Message || "Failed to delete asset allocation");
            }
        } catch (error) {
            toast.error("Error deleting asset allocation");
        }
    };

    // Delete Table Row Function
    const handleDeletetablkerow = async () => {
        try {
            if (selectedRowIndex === -1 || !tableData[selectedRowIndex]) {
                toast.error("Please select a row to delete");
                return;
            }

            // Show confirmation dialog
            const result = await Swal.fire({
                title: 'Delete Row',
                text: 'Are you sure you want to delete this row?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'Cancel'
            });

            if (!result.isConfirmed) {
                return;
            }

            const selectedRow = tableData[selectedRowIndex];
            const UserId = sessionStorage.getItem('UserId');

            // Prepare payload for API call
            const payload = {
                AssetAllocId: selectedRow.AssetAllocId || 0,
                MstAssetId: selectedRow.MstAssetId || 0,
                MstAssetDtlId: selectedRow.MstAssetDtlId || 0,
                PropId: selectedRow.PropId || formData.PropId,
                Flag: "D", // Delete flag
                ActionBy: parseInt(UserId) || 1
            };

            const response = await axiosInstance.post(
                'MstAsset/DeleteTrnAssetAlloct',
                payload
            );

            if (response.data && response.data.Status === 0) {
                toast.success(response.data.Message || "Row deleted successfully");

                // Update local state
                const updatedTableData = [...tableData];
                updatedTableData.splice(selectedRowIndex, 1);
                setTableData(updatedTableData);

                // Reset selection
                if (updatedTableData.length > 0) {
                    setSelectedRowIndex(0); // Select first row after deletion
                } else {
                    setSelectedRowIndex(-1);
                    // Reset other states if no rows left
                    setAllocations({
                        'Unit': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                        'Common Area': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                        'Amenity': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                        'Floor': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' }
                    });
                }
            } else {
                toast.error(response.data?.Message || "Failed to delete row");
            }
        } catch (error) {
            toast.error("Error deleting table row");
        }
    };

    const handleSingleAllocDelete = (type, locIndex) => {
        if (!isFormEditable) {
            toast.error("Form is not in editable mode");
            return;
        }

        const selectedRow = tableData[selectedRowIndex];
        if (!selectedRow || !selectedRow.allocations[type]) {
            toast.error("Invalid allocation data");
            return;
        }

        const updatedTableData = [...tableData];
        const allocation = updatedTableData[selectedRowIndex].allocations[type];
        const location = allocation.selected[locIndex];

        if (!location) {
            toast.error("Invalid location selected for deletion");
            return;
        }

        // If the location has an AssetAllocDtlId (existing record), mark it for deletion
        if (location.AssetAllocDtlId) {
            updatedTableData[selectedRowIndex].originalAssetEntities = updatedTableData[selectedRowIndex].originalAssetEntities || [];
            updatedTableData[selectedRowIndex].originalAssetEntities.push({
                AssetAllocDtlId: location.AssetAllocDtlId,
                MstAssetDtlId: location.MstAssetDtlId,
                MstAssetId: selectedRow.MstAssetId,
                ItmId: selectedRow.ItmId,
                AssestFlag: getAssetFlagFromType(type),
                RoomId: type === "Unit" ? parseInt(location.Id) : 1,
                AmenityId: type === "Amenity" ? parseInt(location.Id) : 1,
                FloorId: type === "Floor" ? parseInt(location.Id) : 1,
                CommonAreaId: type === "Common Area" ? parseInt(location.Id) : 1,
                AllocQty: parseInt(allocation.perUnitQty) || 1,
                PerQty: parseInt(allocation.perUnitQty) || 1,
                Qty: parseInt(allocation.perUnitQty) || 1,
                EmpId: parseInt(allocation.custodian) || 0,
                DBFLAG: "D"
            });
        }

        // Remove the location from selected allocations
        allocation.selected.splice(locIndex, 1);

        // Update noOfLocation
        allocation.noOfLocation = allocation.selected.length.toString();

        // If no locations remain, reset the allocation for this type
        if (allocation.selected.length === 0) {
            allocation.perUnitQty = '';
            allocation.custodian = '';
            allocation.noOfLocation = '';
        }

        // Update BalQty
        const { totalAllocated } = calculateRemainingQty();
        updatedTableData[selectedRowIndex].BalQty = selectedRow.Qty - totalAllocated;

        setTableData(updatedTableData);
        setAllocations({ ...allocations });
        toast.success("Marked for deletion", { autoClose: 500 });
    };

    // Updated Clear function to reset everything
    const handleClear = () => {
        setFormData({
            PropId: "",
            AssetAllocDtlId: 0,
            AssetAllocId: 0,
            MstAssetDtlId: 0,
            MstAssetId: 0,
            AssetAllocNo: "",
            AssetAllocDt: "",
            date: null,
            EmpId: 0,
            CreatedBy: parseInt(sessionStorage.getItem('UserId')) || 0,
            Status: "1",
            PropName: "",
            EmpName: "",
            assetLocation: ""
        });

        setTableData([]);
        setSelectedRowIndex(-1);

        // Reset allocations
        setAllocations({
            'Unit': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
            'Common Area': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
            'Amenity': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
            'Floor': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' }
        });

        // Reset location types
        setSelectedLocationTypes({
            'Unit': false,
            'Common Area': false,
            'Amenity': false,
            'Floor': false
        });

        // Reset quantities
        setOriginalQty(0);
        setRemainingQty(0);

        // Reset position
        setCurrentRecordPosition({ current: 0, total: 0 });
    };

    // Confirm deletion of selected row
    const handleConfirmDelete = () => {
        const updatedTableData = [...tableData];
        const itemFlag = updatedTableData[selectedRowIndex].DBFLAG;
        if (itemFlag === "U" || itemFlag === "R") {
            updatedTableData[selectedRowIndex].DBFLAG = "D";
        } else {
            updatedTableData.splice(selectedRowIndex, 1);
        }
        setTableData(updatedTableData);
        setOpenDeleteDialog(false);
        setSelectedRowIndex(updatedTableData.length > 0 ? 0 : -1);
        setAllButtonDisabled(false);
        setAddDisabled(false);
        setIsFormDisabled(true);
    };

    const handleCheckboxChange = (event, row) => {
        if (event.target.checked) {
            // Add to selected rows if not already present
            if (!selectedRows.some(r => r.MstAssetDtlId === row.MstAssetDtlId)) {
                setSelectedRows([...selectedRows, row]);
            }
        } else {
            // Remove from selected rows by MstAssetDtlId
            setSelectedRows(selectedRows.filter(r => r.MstAssetDtlId !== row.MstAssetDtlId));
        }
    };
    // Add this state for filters
    const [columnFilters, setColumnFilters] = useState(
        tableColumns.reduce((acc, column) => {
            acc[column.id] = '';
            return acc;
        }, {})
    );

    // Add filter handler
    const handleFilterChange = (columnId, value) => {
        setColumnFilters(prev => ({
            ...prev,
            [columnId]: value
        }));
    };

    // Filter the data
    const filteredData = fetchedData.filter(row =>
        tableColumns.every(column => {
            const filterValue = columnFilters[column.id].toLowerCase();
            if (!filterValue) return true;
            const cellValue = String(row[column.id] || '').toLowerCase();
            return cellValue.includes(filterValue);
        })
    );

    // Confirm selection from dialog and add to table
    const handleConfirmSelection = () => {
        if (selectedRows.length === 0) {
            toast.error("Please select at least one record.");
            return;
        }

        // Store the selected asset details for later use in submit
        setSelectedAssetDetails(selectedRows);

        const newTableData = [...tableData];
        selectedRows.forEach((row) => {
            if (!newTableData.some((existingRow) => existingRow.MstAssetDtlId === row.MstAssetDtlId && existingRow.DBFLAG !== "D")) {
                const newRow = {
                    ...row,
                    DBFLAG: 'I'
                };
                newTableData.push(newRow);
            }
        });

        setTableData(newTableData);
        setOpenDialog(false);
        setSelectedRows([]);
        setAddDisabled(true);
        setAllButtonDisabled(false);
        setIsSelectionConfirmed(true);
    };

    useEffect(() => {
        if (location.state && location.state.AssetAllocId) {
            setCurrentEnqId(location.state.AssetAllocId);
            setMode('view');
            setIsFormDisabled(true);
            ritrivefetchAssetData(location.state.AssetAllocId, "R");
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
        fetchPropertyData();
        fetchLedgerData();
        fetchServiceProviderData();
    }, [location]);

    const hasAllocationChanged = (originalEntity, newEntityData) => {
        return (
            originalEntity.AssestFlag !== newEntityData.AssestFlag ||
            originalEntity.RoomId !== newEntityData.RoomId ||
            originalEntity.AmenityId !== newEntityData.AmenityId ||
            originalEntity.FloorId !== newEntityData.FloorId ||
            originalEntity.CommonAreaId !== newEntityData.CommonAreaId ||
            originalEntity.AllocQty !== newEntityData.AllocQty ||
            originalEntity.PerQty !== newEntityData.PerQty ||
            originalEntity.Qty !== newEntityData.Qty ||
            originalEntity.EmpId !== newEntityData.EmpId
        );
    };

    // Fixed retrieve function
    const ritrivefetchAssetData = async (AssetAllocId, flag) => {
        try {
            const UserId = sessionStorage.getItem('UserId');

            const response = await axiosInstance.post(
                'MstAsset/RetriveTrnAssetAlloc',
                {
                    AssetAllocId: AssetAllocId,
                    Flag: flag,
                }
            );

            if (response.data && response.data.Data && response.data.Data.TrnAssetAllocList) {
                const allocData = response.data.Data.TrnAssetAllocList[0];

                // Set main form fields
                setFormData(prev => ({
                    ...prev,
                    PropId: allocData.PropId || "",
                    AssetAllocDtlId: allocData.AssetAllocDtlId,
                    ItmId: allocData.ItmId,
                    AssetAllocId: allocData.AssetAllocId,
                    MstAssetDtlId: allocData.MstAssetDtlId,
                    MstAssetId: allocData.MstAssetId,
                    AssetAllocNo: allocData.AssetAllocNo || "",
                    AssetAllocDt: allocData.AssetAllocDt ? moment(allocData.AssetAllocDt).format('YYYY-MM-DD') : "",
                    date: allocData.AssetAllocDt ? new Date(allocData.AssetAllocDt) : null,
                    EmpId: allocData.EmpId || 0,
                    CreatedBy: allocData.CreatedBy || parseInt(UserId),
                    Status: allocData.Status || "1",
                    PropName: allocData.PropName || "",
                    EmpName: allocData.EmpName || ""
                }));

                // Process barcode entities (top table data)
                const barcodeEntities = allocData.mstAssetBarcodeEntities || [];
                const assetEntities = allocData.mstAssetEntities || [];

                // Create a map of asset locations by BarcodeNo
                const assetLocationsByBarcode = {};
                assetEntities.forEach(entity => {
                    if (!assetLocationsByBarcode[entity.BarcodeNo]) {
                        assetLocationsByBarcode[entity.BarcodeNo] = [];
                    }
                    assetLocationsByBarcode[entity.BarcodeNo].push(entity);
                });

                const tableRows = barcodeEntities.map(entity => {
                    // Create allocations object for this row based on its BarcodeNo
                    const rowAllocations = {
                        'Unit': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                        'Common Area': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                        'Amenity': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                        'Floor': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' }
                    };

                    const rowAssetLocations = assetLocationsByBarcode[entity.BarcodeNo] || [];

                    // Store original asset entities for tracking changes
                    const originalAssetEntities = [];

                    rowAssetLocations.forEach(location => {
                        let type = "";
                        let locationId = 0;
                        let locationName = "";

                        switch (location.AssestFlag) {
                            case 'U':
                                type = 'Unit';
                                locationId = location.RoomId;
                                locationName = location.RoomNo || `Unit ${location.RoomId}`;
                                break;
                            case 'A':
                                type = 'Amenity';
                                locationId = location.AmenityId;
                                locationName = location.AmenityName || `Amenity ${location.AmenityId}`;
                                break;
                            case 'C':
                                type = 'Common Area';
                                locationId = location.CommonAreaId;
                                locationName = location.CommonAreaName || `Common Area ${location.CommonAreaId}`;
                                break;
                            case 'F':
                                type = 'Floor';
                                locationId = location.FloorId;
                                locationName = location.FloorName || `Floor ${location.FloorId}`;
                                break;
                            default:
                                return;
                        }

                        rowAllocations[type].selected.push({
                            Id: locationId,
                            Name: locationName,
                            MstAssetDtlId: location.MstAssetDtlId,
                            AssetAllocDtlId: location.AssetAllocDtlId,
                            DBFLAG: "R"
                        });

                        // Store original entity data for comparison
                        originalAssetEntities.push({
                            AssetAllocDtlId: location.AssetAllocDtlId,
                            ItmId: location.ItmId,
                            MstAssetDtlId: location.MstAssetDtlId,
                            MstAssetId: location.MstAssetId,
                            AssestFlag: location.AssestFlag,
                            RoomId: location.RoomId,
                            AmenityId: location.AmenityId,
                            FloorId: location.FloorId,
                            CommonAreaId: location.CommonAreaId,
                            AllocQty: location.AllocQty,
                            PerQty: location.PerQty,
                            Qty: location.Qty,
                            Rate: location.Rate,
                            EmpId: location.EmpId
                        });

                        // Set allocation details
                        rowAllocations[type].perUnitQty = location.PerQty || location.Qty || 1;
                        rowAllocations[type].noOfLocation = rowAllocations[type].selected.length;
                        rowAllocations[type].custodian = location.EmpId || allocData.EmpId || 0;
                    });

                    return {
                        AssetAllocId: allocData.AssetAllocId,
                        AssetAllocNo: allocData.AssetAllocNo,
                        PropId: allocData.PropId,
                        ItmId: entity.ItmId || 0,
                        ItmName: entity.ItmName || "",
                        AssetAllocDt: allocData.AssetAllocDt ? moment(allocData.AssetAllocDt).format('DD/MM/YYYY') : "",
                        Qty: entity.qty || 0,
                        Rate: entity.Rate || 0,
                        BalQty: entity.BalQty || 0,
                        BarcodeNo: entity.BarcodeNo || "",
                        VendName: entity.VendName || "",
                        SgrnNo: entity.SgrnNo || "",
                        AssetDocNo: entity.AssetDocNo || "",
                        BillDt: entity.BillDt ? moment(entity.BillDt).format('DD/MM/YYYY') : "",
                        BillNo: entity.BillNo || "0",
                        SgrnDt: entity.SgrnDt ? moment(entity.SgrnDt).format('DD/MM/YYYY') : "",
                        ItmCatName: entity.ItmCatName || "",
                        ItmGrpName: entity.ItmGrpName || "",
                        ItmSubGrpName: entity.ItmSubGrpName || "",
                        MstAssetDtlId: entity.MstAssetDtlId,
                        MstAssetId: entity.MstAssetId,
                        allocations: rowAllocations,
                        originalAssetEntities: originalAssetEntities,
                        DBFLAG: "R"
                    };
                });

                setTableData(tableRows);
                setSelectedRowIndex(0);

                // Set allocations for the first row
                if (tableRows.length > 0) {
                    const firstRow = tableRows[0];
                    setAllocations(firstRow.allocations);
                    setOriginalQty(firstRow.Qty || 0);
                    setRemainingQty(firstRow.BalQty || 0);

                    // Set selected location types based on allocations
                    const selectedTypes = {
                        'Unit': false,
                        'Common Area': false,
                        'Amenity': false,
                        'Floor': false
                    };

                    // Check which types have allocations
                    Object.entries(firstRow.allocations).forEach(([type, alloc]) => {
                        if (alloc.selected?.length > 0) {
                            selectedTypes[type] = true;
                            // Fetch locations for this type if not already loaded
                            if (!locationOptions[type] || locationOptions[type].length === 0) {
                                fetchLocationsForType(type, allocData.PropId);
                            }
                        }
                    });

                    setSelectedLocationTypes(selectedTypes);
                }

                // Set position if available
                if (response.data?.Data?.Position) {
                    setCurrentRecordPosition({
                        current: response.data.Data.Position.Current,
                        total: response.data.Data.Position.Total
                    });
                }

                // Set mode to view after loading data
                setMode('view');
                setIsFormDisabled(true);
                setAreTableButtonsDisabled(true);
                setAddDisabled(true);
                setIsPropertyDropdownDisabled(true);
                setAllButtonDisabled(false);
            } else {
                toast.error(response.data?.Message || "No data found for this asset allocation");
            }
        } catch (error) {
            toast.error("Error fetching asset allocation data");
        }
    };

    // Helper function to fetch locations for a specific type
    const fetchLocationsForType = async (type, propId) => {
        try {
            setIsLoadingLocations(true);
            let flag = '';

            switch (type) {
                case 'Unit': flag = 'Rm'; break;
                case 'Common Area': flag = 'Ca'; break;
                case 'Amenity': flag = 'Am'; break;
                case 'Floor': flag = 'Fl'; break;
                default: flag = '';
            }

            const response = await axiosInstance.post('TrnTicketing/getPropertyWisedrp',
                {
                    PropId: propId,
                    flag: flag
                }
            );

            setLocationOptions(prev => ({
                ...prev,
                [type]: response.data?.Data || []
            }));

            if (!response.data?.Data || response.data.Data.length === 0) {
                toast.error(`No ${type} locations found`);
            }
        } catch (error) {
            toast.error(`Error fetching ${type} locations`);
        } finally {
            setIsLoadingLocations(false);
        }
    };

    const handleSubmit = async () => {
        try {
            if (tableData.every(row => !row.allocations || Object.values(row.allocations).every(a => !a.selected?.length))) {
                toast.error("Please make allocations for at least one item");
                return;
            }

            const assetAllocDt = formData.date
                ? moment(formData.date).format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD');

            let finalPayload;

            if (mode === "add") {
                const mainEntry = {
                    AssetAllocDt: assetAllocDt,
                    PropId: parseInt(formData.PropId),
                    EmpId: 0,
                    CreatedBy: parseInt(UserId),
                    DBFLAG: "I",
                    mstAssetEntities: []
                };

                let mainEmpIdSet = false;

                tableData.forEach(row => {
                    if (!row.allocations) return;

                    Object.entries(row.allocations).forEach(([type, alloc]) => {
                        if (alloc.selected?.length > 0) {
                            alloc.selected.forEach(location => {
                                const custodianId = parseInt(alloc.custodian) || 0;

                                if (!mainEmpIdSet && custodianId > 0) {
                                    mainEntry.EmpId = custodianId;
                                    mainEmpIdSet = true;
                                }

                                const entity = {
                                    MstAssetDtlId: row.MstAssetDtlId || 0,
                                    MstAssetId: row.MstAssetId || 0,
                                    PropId: parseInt(formData.PropId),
                                    ItmId: row.ItmId || 0,
                                    AllocQty: parseInt(alloc.perUnitQty) || 1,
                                    NoOfLoc: 1,
                                    PerQty: parseInt(alloc.perUnitQty) || 1,
                                    Qty: parseInt(alloc.perUnitQty) || 1,
                                    Rate: parseFloat(row.Rate) || 0,
                                    Condition: "Good",
                                    Ownership: "Company",
                                    AssestFlag: getAssetFlagFromType(type),
                                    RoomId: type === "Unit" ? parseInt(location.Id) : 1,
                                    AmenityId: type === "Amenity" ? parseInt(location.Id) : 1,
                                    FloorId: type === "Floor" ? parseInt(location.Id) : 1,
                                    CommonAreaId: type === "Common Area" ? parseInt(location.Id) : 1,
                                    PropArea: "North Wing",
                                    Stock: "In Stock",
                                    OutWardDt: moment().format("YYYY-MM-DDTHH:mm:ss"),
                                    AssetTfrId: 1,
                                    IssueDtlId: 1,
                                    NextServDt: moment().add(6, "months").format("YYYY-MM-DDTHH:mm:ss"),
                                    TagNo: "",
                                    RGPDtlID: 1,
                                    EmpId: custodianId,
                                    CreatedBy: parseInt(UserId),
                                    DBFLAG: "I"
                                };
                                mainEntry.mstAssetEntities.push(entity);
                            });
                        }
                    });
                });

                if (mainEntry.EmpId === 0) {
                    toast.error("Please select a valid custodian for the allocation");
                    return;
                }

                finalPayload = [mainEntry];
            } else {
                // UPDATE MODE - FIXED SECTION
                const mainEntry = {
                    AssetAllocId: parseInt(formData.AssetAllocId) || 0,
                    AssetAllocDt: assetAllocDt,
                    PropId: parseInt(formData.PropId),
                    EmpId: parseInt(formData.EmpId) || 0,
                    CreatedBy: parseInt(UserId),
                    DBFLAG: "U", // Main entry is always UPDATE
                    mstAssetEntities: []
                };

                tableData.forEach(row => {
                    if (!row.allocations) return;

                    // Track processed original entities to identify deleted ones
                    const processedOriginalIds = new Set();

                    Object.entries(row.allocations).forEach(([type, alloc]) => {
                        if (alloc.selected?.length > 0) {
                            alloc.selected.forEach(location => {
                                const custodianId = parseInt(alloc.custodian) || 0;

                                // Ensure main entry EmpId is set from allocations if not already set
                                if (mainEntry.EmpId === 0 && custodianId > 0) {
                                    mainEntry.EmpId = custodianId;
                                }

                                // Check if this is an existing allocation using AssetAllocDtlId
                                const existingEntity = row.originalAssetEntities?.find(orig =>
                                    orig.AssetAllocDtlId === location.AssetAllocDtlId
                                );

                                if (existingEntity && location.AssetAllocDtlId) {
                                    // This is an EXISTING entity - mark as processed
                                    processedOriginalIds.add(existingEntity.AssetAllocDtlId);

                                    // Compare to determine if changes were made
                                    const newEntityData = {
                                        AssestFlag: getAssetFlagFromType(type),
                                        RoomId: type === "Unit" ? parseInt(location.Id) : existingEntity.RoomId,
                                        AmenityId: type === "Amenity" ? parseInt(location.Id) : existingEntity.AmenityId,
                                        FloorId: type === "Floor" ? parseInt(location.Id) : existingEntity.FloorId,
                                        CommonAreaId: type === "Common Area" ? parseInt(location.Id) : existingEntity.CommonAreaId,
                                        AllocQty: parseInt(alloc.perUnitQty) || 1,
                                        PerQty: parseInt(alloc.perUnitQty) || 1,
                                        Qty: parseInt(alloc.perUnitQty) || 1,
                                        EmpId: custodianId
                                    };

                                    // Determine DBFLAG based on changes - R for unchanged, U for changed
                                    const dbFlag = hasAllocationChanged(existingEntity, newEntityData) ? "R" : "U";

                                    const entity = {
                                        AssetAllocDtlId: existingEntity.AssetAllocDtlId,
                                        AssetAllocId: parseInt(formData.AssetAllocId) || 0,
                                        MstAssetDtlId: existingEntity.MstAssetDtlId,
                                        MstAssetId: existingEntity.MstAssetId,
                                        PropId: parseInt(formData.PropId),
                                        ItmId: row.ItmId || existingEntity.ItmId || 0,
                                        AllocQty: parseInt(alloc.perUnitQty) || 1,
                                        NoOfLoc: 1,
                                        PerQty: parseInt(alloc.perUnitQty) || 1,
                                        Qty: parseInt(alloc.perUnitQty) || 1,
                                        Rate: parseFloat(row.Rate) || 0,
                                        Condition: "Good",
                                        Ownership: "Company",
                                        AssestFlag: getAssetFlagFromType(type),
                                        RoomId: type === "Unit" ? parseInt(location.Id) : existingEntity.RoomId,
                                        AmenityId: type === "Amenity" ? parseInt(location.Id) : existingEntity.AmenityId,
                                        FloorId: type === "Floor" ? parseInt(location.Id) : existingEntity.FloorId,
                                        CommonAreaId: type === "Common Area" ? parseInt(location.Id) : existingEntity.CommonAreaId,
                                        PropArea: "North Wing",
                                        Stock: "In Stock",
                                        OutWardDt: moment().format("YYYY-MM-DDTHH:mm:ss"),
                                        AssetTfrId: 1,
                                        IssueDtlId: 1,
                                        NextServDt: moment().add(6, "months").format("YYYY-MM-DDTHH:mm:ss"),
                                        TagNo: "",
                                        RGPDtlID: 1,
                                        EmpId: custodianId,
                                        CreatedBy: parseInt(UserId),
                                        DBFLAG: dbFlag
                                    };

                                    mainEntry.mstAssetEntities.push(entity);
                                } else {
                                    // This is a NEW allocation - INSERT with DBFLAG: "I"
                                    // For new entities, get MstAssetDtlId, MstAssetId, and ItmId from the row or existing entities
                                    const mstAssetDtlId = row.MstAssetDtlId ||
                                        (row.originalAssetEntities && row.originalAssetEntities.length > 0 ? row.originalAssetEntities[0].MstAssetDtlId : 0);
                                    const mstAssetId = row.MstAssetId ||
                                        (row.originalAssetEntities && row.originalAssetEntities.length > 0 ? row.originalAssetEntities[0].MstAssetId : 0);
                                    const itmId = row.ItmId ||
                                        (row.originalAssetEntities && row.originalAssetEntities.length > 0 ? row.originalAssetEntities[0].ItmId : 0);

                                    const entity = {
                                        // No AssetAllocDtlId for new entities
                                        AssetAllocId: parseInt(formData.AssetAllocId) || 0,
                                        MstAssetDtlId: mstAssetDtlId,
                                        MstAssetId: mstAssetId,
                                        PropId: parseInt(formData.PropId),
                                        ItmId: itmId,
                                        AllocQty: parseInt(alloc.perUnitQty) || 1,
                                        NoOfLoc: 1,
                                        PerQty: parseInt(alloc.perUnitQty) || 1,
                                        Qty: parseInt(alloc.perUnitQty) || 1,
                                        Rate: parseFloat(row.Rate) || 0,
                                        Condition: "Good",
                                        Ownership: "Company",
                                        AssestFlag: getAssetFlagFromType(type),
                                        RoomId: type === "Unit" ? parseInt(location.Id) : 1,
                                        AmenityId: type === "Amenity" ? parseInt(location.Id) : 1,
                                        FloorId: type === "Floor" ? parseInt(location.Id) : 1,
                                        CommonAreaId: type === "Common Area" ? parseInt(location.Id) : 1,
                                        PropArea: "North Wing",
                                        Stock: "In Stock",
                                        OutWardDt: moment().format("YYYY-MM-DDTHH:mm:ss"),
                                        AssetTfrId: 1,
                                        IssueDtlId: 1,
                                        NextServDt: moment().add(6, "months").format("YYYY-MM-DDTHH:mm:ss"),
                                        TagNo: "",
                                        RGPDtlID: 1,
                                        EmpId: custodianId,
                                        CreatedBy: parseInt(UserId),
                                        DBFLAG: "I" // NEW entity gets INSERT flag
                                    };
                                    mainEntry.mstAssetEntities.push(entity);
                                }
                            });
                        }
                    });

                    // Handle deleted allocations - find entities that were not processed
                    if (row.originalAssetEntities) {
                        row.originalAssetEntities.forEach(originalEntity => {
                            if (!processedOriginalIds.has(originalEntity.AssetAllocDtlId)) {
                                // This entity was deleted - add with DBFLAG: "D"
                                const entity = {
                                    AssetAllocDtlId: originalEntity.AssetAllocDtlId,
                                    AssetAllocId: parseInt(formData.AssetAllocId) || 0,
                                    MstAssetDtlId: originalEntity.MstAssetDtlId,
                                    MstAssetId: originalEntity.MstAssetId,
                                    ItmId: row.ItmId || originalEntity.ItmId || 0,
                                    DBFLAG: "D"
                                };
                                mainEntry.mstAssetEntities.push(entity);
                            }
                        });
                    }
                });

                if (mainEntry.EmpId === 0) {
                    toast.error("Please select a valid custodian for the allocation");
                    return;
                }

                finalPayload = [mainEntry];
            }

            if (finalPayload[0].mstAssetEntities.length === 0) {
                toast.error("No valid allocations to submit");
                return;
            }

            // console.log("Final Payload:", JSON.stringify(finalPayload, null, 2));

            const hasUpdates = finalPayload[0].mstAssetEntities.some(e => e.DBFLAG === 'U');

            // Send to API
            const response = await axiosInstance.post('MstAsset/ManageTrnAssetAlloc', finalPayload);

            if (response.data.Status === 0) {

                // If in add mode, switch to view mode and fetch the newly created record
                if (mode === "add") {
                    toast.success(response.data.Message || 'Record inserted successfully.');
                    setMode('view');
                    setIsFormDisabled(true);
                    setIsFormEditable(false);
                    setAreTableButtonsDisabled(true);
                    setIsPropertyDropdownDisabled(true);
                    setAddDisabled(true);
                    setAllButtonDisabled(false);

                    // Fetch the last record or the newly created record
                    const newAssetAllocId = response.data.Data?.AssetAllocId || null;
                    if (newAssetAllocId) {
                        setCurrentEnqId(newAssetAllocId);
                        await ritrivefetchAssetData(newAssetAllocId, "R");
                    } else {
                        await ritrivefetchAssetData(null, "L");
                    }
                } else if (mode === "edit") {
                    // In edit mode, just refresh the current record
                    toast.success("Data updated successfully.");
                    await ritrivefetchAssetData(formData.AssetAllocId || currentEnqId, "R");
                    setMode('view');
                    setIsFormDisabled(true);
                    setIsFormEditable(false);
                    setAreTableButtonsDisabled(true);
                    setIsPropertyDropdownDisabled(true);
                    setAddDisabled(true);
                    setAllButtonDisabled(false);
                }
            } else {
                toast.error(response.data.Message || "Failed to save asset allocations");
            }
        } catch (error) {
            toast.error('Error submitting asset allocations:', error);
            if (error.response) {
                toast.error(error.response.data.Message || `Error: ${error.response.status} ${error.response.statusText}`);
            } else {
                toast.error("Submission failed: " + error.message);
            }
        }
    };

    // Helper function to convert location type to asset flag
    const getAssetFlagFromType = (type) => {
        switch (type) {
            case 'Unit': return 'U';
            case 'Common Area': return 'C';
            case 'Amenity': return 'A';
            case 'Floor': return 'F';
            default: return '';
        }
    };

    // Update the handlePrevious and handleNext functions:
    const handlePrevious = async () => {
        if (currentEnqId) {
            try {
                await ritrivefetchAssetData(currentEnqId, "P");
            } catch (error) {
                toast.error("Failed to fetch previous record");
            }
        } else {
            toast.error("No current asset selected");
        }
    };

    const handleNext = async () => {
        if (currentEnqId) {
            try {
                await ritrivefetchAssetData(currentEnqId, "N");
            } catch (error) {
                toast.error("Failed to fetch next record");
            }
        } else {
            toast.error("No current asset selected");
        }
    };

    const handleConfirm = async () => {
        try {
            if (selectedRowIndex === -1) {
                toast.error("Please select a row to allocate");
                return;
            }

            const selectedRow = tableData[selectedRowIndex];

            // Verify at least one allocation exists
            const hasAllocations = Object.values(allocations).some(
                alloc => alloc.selected?.length > 0
            );

            if (!hasAllocations) {
                toast.error("Please make at least one allocation");
                return;
            }

            // Calculate total allocated quantity
            const totalAllocated = Object.values(allocations).reduce((sum, alloc) => {
                return sum + (parseInt(alloc.perUnitQty) || 0) * (alloc.selected?.length || 0);
            }, 0);

            // Check if total allocated exceeds the balance
            const remainingQty = selectedRow.BalQty + selectedRow.oldQty;

            if (totalAllocated > remainingQty) {
                toast.error(`Total allocated quantity (${totalAllocated}) exceeds available quantity (${remainingQty})`);
                return;
            }

            // Update the row with allocations and new balance
            const updatedTableData = [...tableData];
            updatedTableData[selectedRowIndex] = {
                ...selectedRow,
                allocations: {
                    ...selectedRow.allocations,
                    [formData.assetLocation]: {
                        ...allocations[formData.assetLocation],
                        selected: allocations[formData.assetLocation].selected || [],
                        custodian: allocations[formData.assetLocation].custodian || '',
                        perUnitQty: allocations[formData.assetLocation].perUnitQty || '',
                        noOfLocation: allocations[formData.assetLocation].noOfLocation || ''
                    }
                },
                BalQty: selectedRow.BalQty - (parseInt(allocations[formData.assetLocation]?.perUnitQty || 0) * (allocations[formData.assetLocation]?.selected?.length || 0)), // Update remaining quantity for this allocation
                DBFLAG: internalMode === "add" ? "I" : "U"
            };

            setTableData(updatedTableData);

            // Reset only the current location type's allocation form 
            setAllocations(prev => ({
                ...prev,
                [formData.assetLocation]: { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' }
            }));

            setRemainingQty(updatedTableData[selectedRowIndex].BalQty);

            // Clear the assetLocation to allow selecting a new type
            setFormData(prev => ({ ...prev, assetLocation: "" }));

        } catch (error) {
            toast.error("Error saving allocations");
        }
    };

    const StyledDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialog-paper': {
            minHeight: '600px',
            maxHeight: '80vh',
            width: '80%',
            maxWidth: '900px'
        },
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2)
        },
        '& .MuiTableCell-root': {
            padding: '8px 16px'
        }
    }));

    const handleAdd = () => {
        setMode('add');
        setCurrentEnqId(null);
        setIsFormDisabled(false);
        setIsFormEditable(true);
        setAddDisabled(false);
        setAllButtonDisabled(true);
        setSelectedRowIndex(-1);
        setIsPropertyDropdownDisabled(false);
        setAreTableButtonsDisabled(false);
        const firstProperty = Propertydrp.length > 0 ? Propertydrp[0] : null;
        const firstCustodian = custodianOptions.length > 0 ? custodianOptions[0] : null;
        setFormData({
            PropId: firstProperty ? firstProperty.Id : "",
            EmpIdId: firstCustodian ? firstCustodian.Id : "",
            SgrnId: "",
            SgrnDt: moment().format('DD/MM/YYYY'),
            date: new Date(),
            ItmId: "",
            Qty: "",
            Rate: "",
            ModelNo: "",
            ModelBrand: "",
            ModelColour: "",
            ModelClass: "",
            ModelOemPartNo: "",
            WarrantyPeriod: "",
            WarrantyUpto: "",
            ExpLife: "",
            RelationId: "",
            MaintFreq: "",
            DepAccLedId: "",
            DepRate: "",
            Remark: "",
            Status: "1",
            assetLocation: "",
        });

        // Clear table data
        setTableData([]);

        // Reset allocation data
        setFetchedQty(0);
        setAllocations({
            'Unit': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
            'Common Area': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
            'Amenity': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
            'Floor': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' }
        });

        // Reset location selections
        setSelectedLocationTypes({
            'Unit': false,
            'Common Area': false,
            'Amenity': false,
            'Floor': false
        });

        // Reset other states
        setIsSelectionConfirmed(false);
        setSelectedAssetData(null);
        setCurrentEnqId(null);
    };

    const handleEdit = () => {
        setMode("edit");
        setIsFormEditable(true);
        setIsFormDisabled(false);
        setAreTableButtonsDisabled(false);
        setIsPropertyDropdownDisabled(false);

        if (selectedRowIndex >= 0 && tableData[selectedRowIndex]) {
            const selectedRow = tableData[selectedRowIndex];

            // Set DBFLAG to "U" for the main entry
            const updatedRow = {
                ...selectedRow,
                DBFLAG: "U", // Set to Update for the main row
                originalAssetEntities: selectedRow.originalAssetEntities || selectedRow.mstAssetEntities || []
            };

            const updatedTableData = [...tableData];
            updatedTableData[selectedRowIndex] = updatedRow;
            setTableData(updatedTableData);

            // Set allocations for editing
            setAllocations(selectedRow.allocations || {
                'Unit': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                'Common Area': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                'Amenity': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                'Floor': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' }
            });

            // Set the first found location type with selected data
            const allocatedType = Object.entries(selectedRow.allocations || {}).find(
                ([_, alloc]) => alloc.selected?.length > 0
            )?.[0] || '';

            setFormData(prev => ({
                ...prev,
                assetLocation: allocatedType
            }));
        } else {
            toast.warn("Please select a row to edit");
        }
    };

    useEffect(() => {
        if (selectedRowIndex >= 0 && tableData[selectedRowIndex]) {
            const selectedRow = tableData[selectedRowIndex];
            // If we're in edit mode and have allocations, keep the assetLocation
            if (isFormEditable && selectedRow.allocations) {
                const currentType = formData.assetLocation;
                const hasAllocationsForType = selectedRow.allocations[currentType]?.selected?.length > 0;

                if (!hasAllocationsForType) {
                    // Find first type with allocations
                    const allocatedType = Object.entries(selectedRow.allocations).find(
                        ([_, alloc]) => alloc.selected?.length > 0
                    )?.[0] || '';

                    if (allocatedType) {
                        setFormData(prev => ({
                            ...prev,
                            assetLocation: allocatedType
                        }));
                    }
                }
            }
        }
    }, [selectedRowIndex, tableData, isFormEditable]);

    const handleCancel = async () => {
        if (mode === 'add') {
            try {
                await ritrivefetchAssetData(null, "L");
            } catch (error) {
                toast.error("Failed to fetch last record");
                // If fetching fails, reset to a clean state
                setMode('view');
                setIsFormDisabled(true);
                setFormData({
                    PropId: Propertydrp.length > 0 ? Propertydrp[0].Id : "",
                    AssetAllocDtlId: 0,
                    AssetAllocId: 0,
                    MstAssetDtlId: 0,
                    MstAssetId: 0,
                    AssetAllocNo: "",
                    AssetAllocDt: "",
                    date: null,
                    EmpId: 0,
                    CreatedBy: parseInt(sessionStorage.getItem('UserId')) || 0,
                    Status: "1",
                    PropName: "",
                    EmpName: "",
                    assetLocation: ""
                });
                setTableData([]);
                setSelectedRowIndex(-1);
                setAddDisabled(true);
                setAllButtonDisabled(false);
                setIsFormEditable(false);
                setIsSelectionConfirmed(false);
                setAllocations({
                    'Unit': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                    'Common Area': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                    'Amenity': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' },
                    'Floor': { selected: [], custodian: '', perUnitQty: '', noOfLocation: '' }
                });
                setSelectedLocationTypes({
                    'Unit': false,
                    'Common Area': false,
                    'Amenity': false,
                    'Floor': false
                });
            }
        } else if (currentEnqId) {
            // If in edit mode or view mode with an existing ID, fetch the current record
            setMode('view');
            setIsFormDisabled(true);
            ritrivefetchAssetData(currentEnqId, "R");
        } else {
            // If no ID (was in add mode with no previous record), clear everything
            setMode('view');
            setIsFormDisabled(true);
            setFormData({
                PropId: Propertydrp.length > 0 ? Propertydrp[0].Id : "",
                AssetAllocDtlId: 0,
                AssetAllocId: 0,
                MstAssetDtlId: 0,
                MstAssetId: 0,
                AssetAllocNo: "",
                AssetAllocDt: "",
                date: null,
                EmpId: 0,
                CreatedBy: parseInt(sessionStorage.getItem('UserId')) || 0,
                Status: "1",
                PropName: "",
                EmpName: "",
                assetLocation: ""
            });
            setTableData([]);
        }
        setSelectedRowIndex(-1);
        setAddDisabled(true);
        setAllButtonDisabled(false);
        setIsFormEditable(false);
        setIsSelectionConfirmed(false);
    };

    // Navigate back to table view
    const handleExit = () => {
        navigate('/assetallocationtable');
    };

    const fetchLedgerData = async () => {
        try {
            const response = await axios.post(
                `AccLed/GetAccLedDrp`,
            );
            if (response.data && response.data.Data) {
                const mappedLedgerData = response.data.Data.map(item => ({
                    Id: item.AccLedId,
                    Name: item.AccLedName
                }));
                setLedgerOptions(mappedLedgerData); // Use the new state variable
            } else {
                toast.error('Invalid ledger data format received');
            }
        } catch (error) {
            toast.error('Error fetching ledger data');
        }
    };

    const fetchServiceProviderData = async () => {
        try {
            const response = await axios.post(
                `PartyMst/getPartyMstdrp`,
                {
                    PartyCat: "SP"
                }
            );
            if (response.data && response.data.Data) {
                // Map the API response to the format expected by the Autocomplete component
                const mappedData = response.data.Data.map(item => ({
                    Id: item.PartyId || item.Id,
                    Name: item.PartyName || item.Name
                }));
                setServiceProviderOptions(mappedData);
            } else {
                toast.error('Invalid service provider data format received');
            }
        } catch (error) {
            toast.error('Error fetching service provider data');
        }
    };

    // Update your useEffect to call both API functions
    useEffect(() => {
        if (location.state && location.state?.EnqId) {
            setCurrentEnqId(location.state.EnqId);
            fetchAssetData(location.state?.EnqId, "R");
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(true);
        }
        fetchPropertyData();
        fetchLedgerData();
        fetchServiceProviderData(); // Add this line
    }, [location]);

    useEffect(() => {
        if (mode === 'edit' && selectedRowIndex >= 0 && tableData[selectedRowIndex]) {
            const selectedRow = tableData[selectedRowIndex];
            const allocatedType = Object.entries(selectedRow.allocations || {}).find(
                ([_, alloc]) => alloc.selected?.length > 0
            )?.[0] || '';

            if (allocatedType) {
                setFormData(prev => ({
                    ...prev,
                    assetLocation: allocatedType
                }));
            }
        }
    }, [mode, selectedRowIndex, tableData]);

    const handleLocationTypeChange = async (type) => {
        if (!formData.PropId) {
            toast.error("Please select a property first");
            return;
        }

        // In edit mode, we want to keep the checkbox checked if there are allocations
        if (mode === 'edit' && allocations[type]?.selected?.length > 0) {
            setFormData(prev => ({
                ...prev,
                assetLocation: type
            }));
            return;
        }

        // Toggle the selected state for add mode
        const newSelectedTypes = {
            ...selectedLocationTypes,
            [type]: !selectedLocationTypes[type]
        };

        setSelectedLocationTypes(newSelectedTypes);
        setFormData(prev => ({
            ...prev,
            assetLocation: type
        }));

        if (newSelectedTypes[type] && (!locationOptions[type] || locationOptions[type].length === 0)) {
            await fetchLocationsForType(type, formData.PropId);
        }
    };

    // Add this useEffect to recalculate remainingQty whenever allocations or fetchedQty changes
    useEffect(() => {
        calculateRemainingQty();
    }, [allocations, fetchedQty]);

    const calculateRemainingQty = () => {
        // Calculate total allocated across all location types
        const totalAllocated = Object.values(allocations).reduce((sum, alloc) => {
            return sum + (parseInt(alloc.perUnitQty) || 0) * (alloc.selected?.length || 0);
        }, 0);

        // Calculate remaining quantity
        const remaining = originalQty - totalAllocated;
        setRemainingQty(remaining >= 0 ? remaining : 0);

        // Return both values for use elsewhere
        return { totalAllocated, remaining };
    };

    return (
        <>
            <ToastContainer /> {/* Toast notification container */}
            <Box className="form-container">
                <Grid container spacing={2} className="AssetAlloc_grid" >
                    {/* Header section */}
                    <Grid item xs={12} className="form_title" sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: "20px",
                        flexDirection: { xs: "column", sm: "row", md: "row" },
                    }}>
                        {/* Navigation buttons */}
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{
                                    backgroundColor: '#635BFF',
                                    marginRight: { xs: '5px', sm: '10px' },
                                    display: 'block',
                                    '&.Mui-disabled': {
                                        backgroundColor: '#d3d3d3',
                                    }
                                }}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{
                                    backgroundColor: '#635BFF',
                                    display: 'block',
                                    '&.Mui-disabled': {
                                        backgroundColor: '#d3d3d3',
                                    }
                                }}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        {/* Title and Property Dropdown in a compact layout */}
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            flexGrow: 1,
                            justifyContent: 'center',
                            flexDirection: { xs: 'column', sm: 'column' }
                        }}>
                            <Typography variant="h5"
                                sx={{
                                    textAlign: "center",
                                    fontSize: { xs: "24px", sm: "18px", md: "24px" },
                                    whiteSpace: 'nowrap',
                                }}>
                                Asset Allocation
                            </Typography>

                            <Box sx={{
                                minWidth: '200px',
                                maxWidth: '250px',
                                '& .MuiAutocomplete-root': {
                                    paddingTop: '0px',
                                    paddingBottom: '0px'
                                },
                                '& .MuiFormControl-root': {
                                    marginTop: '0px',
                                    marginBottom: '0px'
                                },
                                '& .MuiInputBase-root': {
                                    height: '40px'
                                }
                            }}>
                            </Box>
                        </Box>

                        {/* CRUD buttons */}
                        <Grid sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "10px",
                            flexWrap: "wrap"
                        }}>
                            <CrudButtons
                                moduleName="Asset Allocation"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDelete}
                                onExit={handleExit}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Box sx={{ width: "90%", mt: 2, px: 2 }}>
                        <Grid container spacing={1} >
                            <Grid item xs={12} sm={6} md={3}>
                                <Box
                                    sx={{
                                        '& .MuiFormControl-root': { margin: 0 },
                                        '& .MuiInputBase-root': { height: "36px" }
                                    }}
                                >
                                    <CustomAutocomplete
                                        options={Propertydrp}
                                        id="PropId-autocomplete"
                                        name="PropId"
                                        label="Property"
                                        value={Propertydrp.find((prop) => prop.Id == formData.PropId) || null}
                                        onChange={handleInputChange}
                                        disabled={mode === 'view' || isPropertyDropdownDisabled}
                                        size="small"
                                        getOptionLabel={(option) => option.Name || ''}
                                    />
                                </Box>
                            </Grid>

                            {/* Custodian Autocomplete */}
                            <Grid item xs={12} sm={6} md={2}>
                                <Box
                                    sx={{
                                        '& .MuiFormControl-root': { margin: 0 },
                                        '& .MuiInputBase-root': { height: "36px" }
                                    }}
                                >
                                    <Autocomplete
                                        options={custodianOptions}
                                        getOptionLabel={(option) => option.name || ''}
                                        loading={isLoadingCustodians}
                                        value={custodianOptions.find((option) => option.id === parseInt(formData.EmpId)) || null}
                                        onChange={(event, newValue) => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                EmpId: newValue?.id || ""
                                            }));
                                        }}
                                        disabled={!isFormEditable}
                                        size="small"
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                variant="outlined"
                                                label="Allocated To (Custodian)"
                                                name="custodian"
                                            />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                </Box>
                            </Grid>

                            {/* Allocation Id Text Field */}
                            <Grid item xs={12} sm={6} md={2}>
                                <Box
                                    sx={{
                                        '& .MuiFormControl-root': { margin: 0 },
                                        '& .MuiInputBase-root': { height: "36px" }
                                    }}
                                >
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        label="Allocation Id"
                                        name="AssetAllocId"
                                        value={formData.AssetAllocId || ""}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                AssetAllocId: e.target.value
                                            }))
                                        }
                                        size="small"
                                        disabled={!isFormEditable}
                                    />
                                </Box>
                            </Grid>

                            {/* Allocation Date Picker */}
                            <Grid item xs={12} sm={6} md={3}>
                                <Box
                                    sx={{
                                        '& .MuiFormControl-root': { margin: 0 },
                                        '& .MuiInputBase-root': { height: "36px" }
                                    }}
                                >
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Allocation Date"
                                            value={formData.date || null}
                                            onChange={(newValue) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    date: newValue
                                                }));
                                            }}
                                            disabled={!isFormEditable}
                                            inputFormat="dd/MM/yyyy"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <Tooltip title='Check Asset Details' arrow>
                                    <span style={{ display: 'inline-block' }}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClickAdd}
                                            disabled={addDisabled || areTableButtonsDisabled}
                                            size="small"
                                            sx={{
                                                minWidth: 50,
                                                height: '36px',
                                                padding: 1,
                                                borderRadius: '8px',
                                                backgroundColor: '#635BFF',
                                            }}
                                        >
                                            <AddIcon fontSize="small" /> Add Item
                                        </Button>
                                    </span>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* Table section */}
                    <Grid item xs={12}>
                        <Paper sx={{ width: "100%", overflow: "hidden", margin: "auto", border: "1px solid lightgray" }}>
                            <TableContainer sx={{ maxHeight: 300 }}>
                                <Table
                                    stickyHeader
                                    size="small"
                                    sx={{
                                        '& .MuiTableCell-root': {
                                            padding: '1.4px 3px',
                                            lineHeight: '1.2',
                                        },
                                        '& .MuiTableRow-root': {
                                            height: '0px',
                                        }
                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            {tableColumns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    style={{
                                                        minWidth: column.minWidth,
                                                        padding: '0px',
                                                        backgroundColor: '#e4e1e1ff'
                                                    }}
                                                >
                                                    <Typography variant="subtitle2" fontWeight="bold">{column.label}</Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {tableData
                                            .filter(row => row.DBFLAG !== "D")
                                            .map((row, index) => {
                                                const isSelected = selectedRowIndex === index;
                                                return (
                                                    <TableRow
                                                        hover
                                                        key={index}
                                                        onClick={() => handleRowClick(index)}
                                                        selected={isSelected}
                                                        sx={{
                                                            '&.Mui-selected': {
                                                                backgroundColor: '#e3f2fd',
                                                            },
                                                            '&.Mui-selected:hover': {
                                                                backgroundColor: '#bbdefb',
                                                            }
                                                        }}
                                                    >
                                                        {tableColumns.map((column) => {
                                                            const cellValue = row[column.id];
                                                            return (
                                                                <TableCell
                                                                    key={column.id}
                                                                    sx={{
                                                                        padding: '6px 8px',
                                                                        fontSize: '0.85rem'
                                                                    }}
                                                                >
                                                                    {cellValue !== undefined && cellValue !== null ? cellValue.toString() : "0"}
                                                                </TableCell>
                                                            );
                                                        })}
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>

                    {/* Selection dialog */}
                    {openDialog && (
                        <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="lg" fullWidth>
                            <DialogTitle>Select Records</DialogTitle>
                            <DialogContent sx={{
                                overflowY: 'auto',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                paddingBottom: '10px'
                            }}>
                                <TableContainer sx={{
                                    maxHeight: '55vh',
                                    width: '100%',
                                    '& .MuiTableCell-root': {
                                        padding: '4px 6px',
                                        lineHeight: '1.1',
                                        fontSize: '0.85rem'
                                    },
                                    '& .MuiTableRow-root': {
                                        height: '2px',
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                        }
                                    }
                                }}>
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow sx={{
                                                '& .MuiTableCell-head': {
                                                    backgroundColor: '#f5f5f5',
                                                    padding: '5px',
                                                    fontWeight: 'bold'
                                                }
                                            }}>
                                                <TableCell align="center" sx={{ width: '50px' }}>Select</TableCell>
                                                {tableColumns.map((column) => (
                                                    <TableCell
                                                        key={column.id}
                                                        align="center"
                                                        sx={{ minWidth: column.minWidth }}
                                                    >
                                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                            <Typography variant="subtitle2">{column.label}</Typography>
                                                            <TextField
                                                                size="small"
                                                                variant="outlined"
                                                                value={columnFilters[column.id]}
                                                                onChange={(e) => handleFilterChange(column.id, e.target.value)}
                                                                sx={{
                                                                    marginTop: '4px',
                                                                    '& .MuiInputBase-root': {
                                                                        height: '28px'
                                                                    }
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredData.map((row, index) => (
                                                <TableRow
                                                    key={`row-${index}`}
                                                    sx={{
                                                        '&.Mui-selected': {
                                                            backgroundColor: '#e3f2fd'
                                                        }
                                                    }}
                                                >
                                                    <TableCell align="center">
                                                        <Checkbox
                                                            size="small"
                                                            checked={selectedRows.some(r => r.MstAssetDtlId === row.MstAssetDtlId)}
                                                            onChange={(e) => handleCheckboxChange(e, row)}
                                                        />
                                                    </TableCell>
                                                    {tableColumns.map((column) => (
                                                        <TableCell
                                                            key={`${column.id}-${index}`}
                                                            align="center"
                                                        >
                                                            {row[column.id] || "N/A"}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </DialogContent>
                            <DialogActions sx={{
                                padding: '8px 16px',
                                borderTop: '1px solid #e0e0e0'
                            }}>
                                <Button
                                    onClick={handleConfirmSelection}
                                    color="primary"
                                    size="small"
                                    sx={{ minWidth: '80px' }}
                                    disabled={selectedRows.length === 0}
                                >
                                    Confirm
                                </Button>
                                <Button
                                    onClick={() => {
                                        setOpenDialog(false);
                                        setSelectedRows([]);
                                        setColumnFilters(tableColumns.reduce((acc, column) => {
                                            acc[column.id] = '';
                                            return acc;
                                        }, {}));
                                    }}
                                    color="secondary"
                                    size="small"
                                    sx={{ minWidth: '80px' }}
                                >
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}

                    {/* Form fields - Restructured for left-right layout */}
                    <Grid item xs={12} md={12} lg={12} className="form_field"
                        sx={{
                            marginInline: { xs: "10px", sm: "20px" },
                            marginTop: "0px",
                            paddingTop: "0px",
                        }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={6} sx={{ paddingLeft: '0px !important' }}>
                                <Paper elevation={2}
                                    sx={{
                                        height: '40vh',
                                        minHeight: '200px',
                                        overflow: 'auto',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 0,
                                        backgroundColor: '#f9f9f9',
                                        mb: 0,
                                    }}>
                                    {/* Asset Location Section */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 1 }}>
                                        <Typography
                                            variant="subtitle1"
                                            sx={{
                                                fontWeight: 'bold',
                                                color: '#635BFF',
                                                whiteSpace: 'nowrap',
                                                borderBottom: '1px solid #e0e0e0',
                                            }}
                                        >
                                            Location →
                                        </Typography>

                                        {/* Checkboxes */}
                                        <FormGroup row sx={{ m: 0 }}>
                                            {['Unit', 'Common Area', 'Amenity', 'Floor'].map((type) => {
                                                const hasAllocations = allocations[type]?.selected?.length > 0;
                                                const isChecked = selectedLocationTypes[type] || hasAllocations;

                                                return (
                                                    <FormControlLabel
                                                        key={type}
                                                        control={
                                                            <Checkbox
                                                                checked={isChecked}
                                                                onChange={() => {
                                                                    if (!isFormEditable && mode !== 'edit') return;
                                                                    handleLocationTypeChange(type);
                                                                }}
                                                                size="small"
                                                                sx={{
                                                                    color: '#635BFF',
                                                                    '&.Mui-checked': { color: '#635BFF' },
                                                                    '&.Mui-disabled': {
                                                                        color: isChecked ? '#635BFF' : 'default',
                                                                    },
                                                                }}
                                                                disabled={mode === 'view' || !isFormEditable}
                                                            />
                                                        }
                                                        label={type}
                                                        sx={{
                                                            '& .MuiFormControlLabel-label': {
                                                                fontSize: '0.95rem',
                                                                fontWeight: isChecked ? 'bold' : 'normal',
                                                                color: isChecked ? '#635BFF' : 'inherit',
                                                            },
                                                        }}
                                                    />
                                                );
                                            })}
                                        </FormGroup>
                                    </Box>

                                    {/* Location Allocation Form - Inline instead of modal */}
                                    {formData.assetLocation && (
                                        <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '4px', p: 1 }}>
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
                                                <Typography variant="subtitle2" color='secondary' sx={{ fontWeight: 'bold' }}>
                                                    {formData.assetLocation} Allocation
                                                </Typography>
                                                {mode === 'edit' && (
                                                    <Typography variant="body2" color="textSecondary">
                                                        (Edit Mode)
                                                    </Typography>
                                                )}

                                                <Typography variant="body2" color="primary" sx={{ ml: 'auto' }}>
                                                    Total Allocated: {originalQty - (selectedAssetData?.BalQty || originalQty || 0)} |
                                                    Remaining: {fetchedQty}
                                                </Typography>
                                            </Box>

                                            <Grid container spacing={1} sx={{ mt: 1 }}>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        label="Allocate Qty"
                                                        className="custom-textfield"
                                                        value={selectedRowIndex >= 0 ? tableData[selectedRowIndex].BalQty : fetchedQty}
                                                        disabled={!isFormEditable}
                                                        InputProps={{
                                                            readOnly: true,
                                                            style: {
                                                                backgroundColor: isFormEditable ? '#f5f5f5' : '#e0e0e0'
                                                            }
                                                        }}
                                                        sx={{
                                                            '& .MuiFilledInput-root': {
                                                                backgroundColor: isFormEditable ? '#f5f5f5' : '#e0e0e0'
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Autocomplete
                                                        options={custodianOptions}
                                                        getOptionLabel={(option) => option.name}
                                                        loading={isLoadingCustodians}
                                                        value={custodianOptions.find(option =>
                                                            option.id === parseInt(allocations[formData.assetLocation]?.custodian)
                                                        ) || null}
                                                        onChange={(event, newValue) => {
                                                            if (!isFormEditable) return;
                                                            setAllocations(prev => ({
                                                                ...prev,
                                                                [formData.assetLocation]: {
                                                                    ...prev[formData.assetLocation],
                                                                    custodian: newValue?.id || ""
                                                                }
                                                            }));
                                                        }}
                                                        disabled={!isFormEditable}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                variant="filled"
                                                                label="Custodian"
                                                                className="custom-textfield"
                                                                name="custodian"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    style: {
                                                                        paddingTop: '0px',
                                                                        paddingBottom: '0px',
                                                                        backgroundColor: isFormEditable ? '#f5f5f5' : '#e0e0e0'
                                                                    }
                                                                }}
                                                                sx={{
                                                                    '& .MuiInputBase-root': {
                                                                        backgroundColor: isFormEditable ? '#f5f5f5' : '#e0e0e0'
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        label="Per Unit Qty"
                                                        name="perUnitQty"
                                                        type="number"
                                                        className="custom-textfield"
                                                        value={allocations[formData.assetLocation]?.perUnitQty || ''}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const perUnitQty = parseInt(value) || 0;

                                                            if (value === '') {
                                                                setAllocations(prev => ({
                                                                    ...prev,
                                                                    [formData.assetLocation]: {
                                                                        ...prev[formData.assetLocation],
                                                                        perUnitQty: '',
                                                                        noOfLocation: ''
                                                                    }
                                                                }));
                                                                return;
                                                            }

                                                            if (perUnitQty < 1) {
                                                                toast.error("Per Unit Qty must be at least 1");
                                                                return;
                                                            }

                                                            if (perUnitQty > fetchedQty) {
                                                                toast.error(`Per Unit Qty cannot exceed total available quantity (${fetchedQty})`);
                                                                return;
                                                            }

                                                            setAllocations(prev => ({
                                                                ...prev,
                                                                [formData.assetLocation]: {
                                                                    ...prev[formData.assetLocation],
                                                                    perUnitQty: value,
                                                                    noOfLocation: ''
                                                                }
                                                            }));
                                                        }}
                                                        disabled={!isFormEditable}
                                                        helperText={`Max: ${fetchedQty}`}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        fullWidth
                                                        variant="filled"
                                                        label="No of Location"
                                                        name="noOfLocation"
                                                        type="number"
                                                        className="custom-textfield"
                                                        value={
                                                            mode === 'view' && allocations[formData.assetLocation]?.selected?.length > 0
                                                                ? allocations[formData.assetLocation].selected.length
                                                                : allocations[formData.assetLocation]?.noOfLocation || ''
                                                        }
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const noOfLocation = parseInt(value) || 0;
                                                            const perUnitQty = parseInt(allocations[formData.assetLocation]?.perUnitQty) || 0;

                                                            // Calculate remaining after other allocations
                                                            const otherAllocations = Object.entries(allocations)
                                                                .filter(([t, _]) => t !== formData.assetLocation)
                                                                .reduce((sum, [_, alloc]) => {
                                                                    return sum + ((parseInt(alloc.perUnitQty) || 0) * (alloc.selected?.length || 0));
                                                                }, 0);

                                                            const remainingAfterOthers = originalQty - otherAllocations;

                                                            if (value === '') {
                                                                setAllocations(prev => ({
                                                                    ...prev,
                                                                    [formData.assetLocation]: {
                                                                        ...prev[formData.assetLocation],
                                                                        noOfLocation: ''
                                                                    }
                                                                }));
                                                                return;
                                                            }

                                                            if (!perUnitQty) {
                                                                toast.error("Please enter Per Unit Qty first");
                                                                return;
                                                            }
                                                            const maxLocations = Math.floor(remainingAfterOthers / perUnitQty);

                                                            if (noOfLocation < 1) {
                                                                toast.error("No of Location must be at least 1");
                                                                return;
                                                            }

                                                            if (noOfLocation > maxLocations) {
                                                                toast.error(`You Can not allocate more than Balance Quantity, remaining quantity is ${maxLocations} `);
                                                                return;
                                                            }

                                                            setAllocations(prev => ({
                                                                ...prev,
                                                                [formData.assetLocation]: {
                                                                    ...prev[formData.assetLocation],
                                                                    noOfLocation: value
                                                                }
                                                            }));
                                                        }}
                                                        disabled={!isFormEditable || !allocations[formData.assetLocation]?.perUnitQty}
                                                        helperText={
                                                            allocations[formData.assetLocation]?.perUnitQty
                                                                ? `Max: ${Math.floor(
                                                                    (originalQty - Object.entries(allocations)
                                                                        .filter(([t, _]) => t !== formData.assetLocation)
                                                                        .reduce((sum, [_, alloc]) => {
                                                                            return sum + ((parseInt(alloc.perUnitQty) || 0) * (alloc.selected?.length || 0));
                                                                        }, 0)
                                                                    ) / parseInt(allocations[formData.assetLocation]?.perUnitQty)
                                                                )}`
                                                                : 'Enter Per Unit Qty first'
                                                        }
                                                    />
                                                </Grid>
                                            </Grid>
                                            {(isFormEditable || (formData.assetLocation && allocations[formData.assetLocation]?.selected?.length > 0)) && (
                                                <Autocomplete
                                                    multiple
                                                    id="locations-autocomplete"
                                                    options={locationOptions[formData.assetLocation] || []}
                                                    disableCloseOnSelect
                                                    getOptionLabel={(option) => option.Name || ''}
                                                    value={allocations[formData.assetLocation]?.selected || []}
                                                    onChange={(event, newValue) => {
                                                        if (!isFormEditable) return;
                                                        const currentAllocation = allocations[formData.assetLocation];
                                                        const maxLocations = parseInt(currentAllocation?.noOfLocation) || 0;

                                                        if (maxLocations > 0 && newValue.length > maxLocations) {
                                                            toast.error(`You can only select ${maxLocations} locations`);
                                                            return;
                                                        }

                                                        setAllocations(prev => ({
                                                            ...prev,
                                                            [formData.assetLocation]: {
                                                                ...prev[formData.assetLocation],
                                                                selected: newValue
                                                            }
                                                        }));
                                                    }}
                                                    loading={isLoadingLocations}
                                                    disabled={!isFormEditable}

                                                    // Custom popper for dropdown height
                                                    PopperComponent={(props) => (
                                                        <Popper
                                                            {...props}
                                                            placement="bottom-start"
                                                            modifiers={[
                                                                {
                                                                    name: 'offset',
                                                                    options: {
                                                                        offset: [0, 4],
                                                                    },
                                                                },
                                                            ]}
                                                            sx={{
                                                                maxHeight: 400,
                                                                overflowY: 'auto',
                                                                '& .MuiAutocomplete-listbox': {
                                                                    display: 'grid',
                                                                    gridTemplateColumns: 'repeat(4, 1fr)', // 4 columns
                                                                    columnGap: '12px',
                                                                    padding: '4px 8px',
                                                                },
                                                                '& li': {
                                                                    minHeight: '32px',
                                                                    paddingTop: '4px',
                                                                    paddingBottom: '4px',
                                                                },
                                                            }}
                                                        />
                                                    )}

                                                    renderOption={(props, option, { selected }) => (
                                                        <li
                                                            {...props}
                                                            style={{
                                                                padding: '4px 8px',
                                                                fontSize: '0.85rem',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '6px',
                                                                minHeight: '32px',
                                                            }}
                                                        >
                                                            <Checkbox
                                                                style={{ padding: 0, marginRight: 6 }}
                                                                checked={selected}
                                                                disabled={!isFormEditable}
                                                            />
                                                            {option.Name}
                                                        </li>
                                                    )}

                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="filled"
                                                            className="custom-textfield"
                                                            label={`Select ${formData.assetLocation}`}
                                                            placeholder={isLoadingLocations ? "Loading locations..." : "Select locations..."}
                                                            helperText={
                                                                allocations[formData.assetLocation]?.noOfLocation &&
                                                                    allocations[formData.assetLocation]?.selected.length !== parseInt(allocations[formData.assetLocation]?.noOfLocation)
                                                                    ? `Please select exactly ${allocations[formData.assetLocation]?.noOfLocation} locations`
                                                                    : ''
                                                            }
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                disableUnderline: false,
                                                                style: {
                                                                    backgroundColor: isFormEditable ? '#f5f5f5' : '#e0e0e0'
                                                                },
                                                                endAdornment: (
                                                                    <>
                                                                        {isLoadingLocations ? <CircularProgress color="inherit" size={20} /> : null}
                                                                        {params.InputProps.endAdornment}
                                                                    </>
                                                                ),
                                                            }}
                                                        />
                                                    )}
                                                    sx={{
                                                        mb: 2,
                                                        '& .MuiFilledInput-root': {
                                                            backgroundColor: isFormEditable ? '#f5f5f5' : '#e0e0e0'
                                                        }
                                                    }}
                                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                    noOptionsText="No locations available"
                                                />
                                            )}
                                            {mode !== 'view' && (
                                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        onClick={handleConfirm}
                                                        disabled={!Object.values(allocations).some(a => a.selected?.length > 0)}
                                                        sx={{
                                                            backgroundColor: '#4caf50',
                                                            '&:hover': { backgroundColor: '#388e3c' },
                                                        }}
                                                    >
                                                        Confirm
                                                    </Button>
                                                    <Button
                                                        variant="outlined"
                                                        onClick={() => setFormData(prev => ({ ...prev, assetLocation: "" }))}
                                                        size="small"
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                </Paper>
                            </Grid>

                            <Grid item xs={12} md={6} lg={6}>
                                <Paper
                                    elevation={2}
                                    sx={{
                                        px: 1,
                                        height: '40vh', // Match the height of the left-side Paper
                                        minHeight: '200px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        backgroundColor: '#f9f9f9',
                                        overflow: 'hidden', // Prevent content from spilling out
                                    }}
                                >
                                    <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                                        {selectedRowIndex >= 0 && tableData[selectedRowIndex]?.allocations && (
                                            <Box sx={{ height: '100%' }}>
                                                <Typography
                                                    variant="subtitle1"
                                                    sx={{
                                                        fontWeight: 'bold',
                                                        color: '#635BFF',
                                                        borderBottom: '1px solid #e0e0e0',
                                                    }}
                                                >
                                                    Allocation Details
                                                </Typography>
                                                <TableContainer
                                                    sx={{
                                                        maxHeight: 'calc(100% - 40px)', // Account for title height
                                                        overflowY: 'auto',
                                                        overflowX: 'auto',
                                                        '&::-webkit-scrollbar-thumb': {
                                                            backgroundColor: '#888',
                                                            borderRadius: '3px',
                                                        },
                                                        '&::-webkit-scrollbar-thumb:hover': {
                                                            backgroundColor: '#555',
                                                        },
                                                    }}
                                                >
                                                    <Table
                                                        size="small"
                                                        stickyHeader
                                                        sx={{
                                                            '& .MuiTableCell-root': {
                                                                padding: '3px 7px', // Compact padding
                                                                fontSize: '0.85rem', // Smaller font for readability
                                                                lineHeight: '1',
                                                            },
                                                            '& .MuiTableRow-root': {
                                                            },
                                                            '& .MuiTableHead': {
                                                                backgroundColor: '#f5f5f5', // Header background
                                                            },
                                                        }}
                                                    >
                                                        <TableHead>
                                                            <TableRow sx={{
                                                                '& th': {
                                                                    backgroundColor: 'rgba(195, 209, 223, 1)',
                                                                },
                                                            }}>
                                                                <TableCell>Sr.No</TableCell>
                                                                <TableCell>Type</TableCell>
                                                                <TableCell>Loc_Name</TableCell>
                                                                <TableCell>No_of_Loc</TableCell>
                                                                <TableCell>Unit/QTY</TableCell>
                                                                <TableCell>Total</TableCell>
                                                                <TableCell>Custodian</TableCell>
                                                                <TableCell>Actions</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(tableData[selectedRowIndex].allocations)
                                                                .filter(([_, alloc]) => alloc.selected?.length > 0)
                                                                .flatMap(([type, alloc], typeIndex) =>
                                                                    alloc.selected.map((loc, index) => (
                                                                        <TableRow key={`${type}-${loc.Id}-${index}`}>
                                                                            <TableCell>{typeIndex * alloc.selected.length + index + 1}</TableCell>
                                                                            <TableCell>{type}</TableCell>
                                                                            <TableCell>{loc.Name}</TableCell>
                                                                            <TableCell>1</TableCell>
                                                                            <TableCell>{alloc.perUnitQty}</TableCell>
                                                                            <TableCell>{alloc.perUnitQty}</TableCell>
                                                                            <TableCell>
                                                                                {custodianOptions.find((c) => c.id === parseInt(alloc.custodian))?.name || alloc.custodian}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Tooltip title="Delete the record" arrow>
                                                                                    <span>
                                                                                        <IconButton
                                                                                            size="small"
                                                                                            color="error"
                                                                                            onClick={() => handleSingleAllocDelete(type, index)}
                                                                                            disabled={mode === 'view' || !isFormEditable}
                                                                                        >
                                                                                            <DeleteIcon fontSize="small" />
                                                                                        </IconButton>
                                                                                    </span>
                                                                                </Tooltip>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                )}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Box>
                                        )}
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Submit/Cancel buttons */}
                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: 'linear-gradient(290deg, #d4d4d4, #ffffff)',
                                        '&.Mui-disabled': {
                                            background: 'linear-gradient(290deg, #d4d4d4, #ffffff)',
                                            color: 'rgba(0, 0, 0, 0.26)'
                                        }
                                    }}
                                    onClick={handleAdd}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: 'linear-gradient(290deg, #a7c5e9, #ffffff)',
                                        '&.Mui-disabled': {
                                            background: 'linear-gradient(290deg, #a7c5e9, #ffffff)',
                                            color: 'rgba(0, 0, 0, 0.26)'
                                        }
                                    }}
                                    onClick={handleCancel}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        backgroundColor: '#635bff',
                                        '&:hover': { backgroundColor: '#4a2fdb' }
                                    }}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        backgroundColor: '#635bff',
                                        '&:hover': { backgroundColor: '#4a2fdb' }
                                    }}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                <PrintAssetAlloc
                    contentRef={contentRef}
                    formData={formData}
                    propertyList={Propertydrp}
                    tableData={tableData}
                    allocations={allocations}
                />
            </div>

            {/* Delete confirmation dialog */}
            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>Are you sure you want to delete this record?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ backgroundColor: '#635bff', color: 'white', '&:hover': { backgroundColor: '#1565c0' } }} onClick={handleConfirmDelete}>Yes</Button>
                    <Button sx={{ backgroundColor: '#635bff', color: 'white', '&:hover': { backgroundColor: '#1565c0' } }} onClick={() => setOpenDeleteDialog(false)}>No</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AssetAlloc;